import { render, staticRenderFns } from "./PayByTerminal.vue?vue&type=template&id=30363a18&"
import script from "./PayByTerminal.vue?vue&type=script&lang=js&"
export * from "./PayByTerminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports